export const UserType = Object.freeze({
    NONE:       "",
    FAMILY:     "family",
    NANNY:      "nanny"
});

export const NoOfChildren = Object.freeze({
    NONE:       "",
    UNLIMITED:  "unlimited",
    UP_TO_TWO:  "two",
    ONE:        "one"
});

export const AgeOfChildren = Object.freeze({
    NONE:       "",
    NO_MATTER:  "no_matter",
    SPECIFIC:   "specific"
});

export const AvailabilityTime = Object.freeze({
    NONE:       "",
    HOURLYWISE: "hourlywise",
    HALF_DAY:   "half_day",
    FULL_DAY:   "full_day"
});

export const WeekDays = Object.freeze({
    NONE:       "",
    FLEXIBLE:   "flexible",
    SPECIFIC:   "specific"
});

export const Start = Object.freeze({
    NONE:       "",
    ASAP:       "asap",
    SPECIFIC:   "specific"
});

export const Notifications = Object.freeze({
    NONE:       "",
    E_MAIL:     "email",
    // SMS:        "sms"
});

export const AvailabilityByPhone = Object.freeze({
    NONE:       "",
    ALWAYS:     "always",
    SPECIFIC:   "specific"
});

export const Recommendation = Object.freeze({
    NONE:       "",
    FRIENDS:    "friends",
    INSTAGRAM:  "instagram",
    FACEBOOK:   "facebook",
    LINKEDIN:   "linkedin",
    UNI:        "uni",
    WEBSITE:    "website",
    OTHER:      "other"
});

export const Gender = Object.freeze({
    NONE:       "",
    MALE:       "male",
    FEMALE:     "female",
    DIVERSE:    "diverse"
});

export const GenderNanny = Object.freeze({
    NONE:       "",
    NO_MATTER:  "no_matter",
    MALE:       "male",
    FEMALE:     "female",
    DIVERSE:    "diverse"
});

export const Salutation = Object.freeze({
    NONE:       "",
    MR:         "mr",
    MRS:        "mrs",
    DIVERSE:    "diverse"
});

export const Title = Object.freeze({
    NONE:       "",
    DR:         "dr",
    PROF:       "prof",
    PROF_DR:    "prof_dr"
});

// The entries should be in alphabetic order (requirement from Tommy)
export const Location = Object.freeze({
    NONE:                   "",
    RHINE_RUHR:             "rhine_ruhr",
    BERLIN_BRANDENBURG:     "berlin_brandenburg",
    MUNICH:                 "munich",
    RHINE_MAIN:             "rhine_main",
    HAMBURG:                "hamburg",
    NUREMBERG:              "nuremberg",
    STUTTGART:              "stuttgart",
    RHINE_NECKAR:           "rhine_neckar",
    CENTRAL_GERMANY:        "central_germany",
    UPPER_RHINE:            "upper_rhine",
    BREMEN:                 "bremen",
    OTHER:                  "other"
});

export const LocationStartPage = Object.freeze({
    BERLIN:                 "berlin",
    MUNICH:                 "munich",
    NUREMBERG:              "nuremberg",
    HAMBURG:                "hamburg",
    FRANKFURT:              "frankfurt",
    COLOGNE:                "cologne"
});

export const Graduation = Object.freeze({
    NONE:                       "",
    BASIC_SCHOOL:               "basic_school",
    SECONDARY_SCHOOL:           "secondary_school",
    HIGH_SCHOOL_SPECIALIZED:    "high_school_specialized",
    HIGH_SCHOOL:                "high_school",
    UNIVERSITY:                 "university",
    TRAINING:                   "training"
});

export const Language = Object.freeze({
    NONE: "",
    GERMAN: "de",
    ENGLISH: "en",
    FRENCH: "fr",
    SPANISH: "es",
    ITALIAN: "it",
    TURKISH: "tr",
    LATIN: "la",
    POLISH: "pl",
    DUTCH: "nl",
    PORTUGUESE: "pt"
});

export const LanguageLevel = Object.freeze({
    NONE:           "",
    MOTHER_TONGUE:  "mother_tongue",
    FLUENTLY:       "fluently",
    INTERMEDIATE:   "intermediate",
    BEGINNER:       "beginner"
});

// Do not change the order!
export const MediationStatus = Object.freeze({
    NONE:                               "",
    DATA_COLLECTED:                     "data_collected",
    APPLICATION_INTERESTING:            "application_interesting",
    ONLINE_MEETING:                     "online_meeting",
    VOTING:                             "voting",
    PROTECTION_FEE:                     "protection_fee",
    PROTECTION_FEE_INVOICE_AVAILABLE:   "protection_fee_invoice_available",
    FIND_MATCH:                         "find_match",
    MATCH_FOUND:                        "match_found",
    FINAL_CONFIRMATION:                 "final_confirmation",
    MEDIATION_FEE:                      "mediation_fee",
    MEDIATION_FEE_INVOICE_AVAILABLE:    "mediation_fee_invoice_available",
    MEDIATION_DONE:                     "mediation_done"
});

export const UploadInputState = Object.freeze({
    NONE:                       0,
    SELECT:                     1,
    SELECTED:                   2,
    UPLOADING:                  3,
    DELETING:                   4,
    UPLOADED:                   5
});

export const LoadState = Object.freeze({
    NONE:               0,
    LOADING:            1,
    LOAD_ERROR:         2,
    LOAD_SUCCESS:       3
});

export const UserCategory = Object.freeze({
    NONE:         "",
    A:            "a",
    B:            "b",
    C:            "c"
});

export const CommunicationTool = Object.freeze({
    NONE:             "",
    TEAMS:            "teams",
    ZOOM:             "zoom",
    FACETIME:         "facetime",
    WEBEX:            "webex",
    OTHER:            "other"
});

export const Filter = Object.freeze({
    APPLICATION:            "application",
    FIRST_CONTACT:          "first_contact",
    ONLINE_MEETING:         "online_meeting",
    VOTING:                 "voting",
    MATCH:                  "match",
    PROTECTION_FEE:         "protection_fee",
    MEDIATION_FEE:          "mediation_fee",
    MATCH_SEARCH:           "match_search",
    MATCH_TO_MN:            "match_to_mn",
    MATCH_TO_FAM:           "match_to_fam",
    MATCH_DECLINED:         "match_declined",
    RELEASE_CONTACT:        "release_contact",
    FINAL_CONFIRMATION:     "final_confirmation",
    MEDIATION_DONE:         "mediation_done",

    /* USER_TYPE:              "user_type",
    SEARCH_TEXT:            "search_text", */

    CATEGORY_A:             "category_a",
    CATEGORY_B:             "category_b",
    CATEGORY_C:             "category_c",

    ON_SHORT_CALL:          "on_short_call",
    PAUSED_ACCOUNTS:        "paused_accounts",
    PAUSED_ACCOUNTS_ONLY:   "paused_accounts_only",

    MATCH_USER_ID:          "match_user_id",

    USER_WITHOUT_DATA_COLLECTION: "user_without_data_collection",

    PARKED_ACCOUNTS:        "parked_accounts",
    PARKED_ACCOUNTS_ONLY:   "parked_accounts_only",

    DECLINED_ACCOUNTS:      "declined_accounts",

    LOCATION:               "location"

    /*MATCH_PERCENTAGE:       "match_percentage" */
});

export const MatchFilter = Object.freeze({
    DONE_MATCHES:            "done_matches",
    LOCATION:                "location"
});

// Do not change the order!
export const MatchStatus = Object.freeze({
    NONE:               "",
    SENT_TO_MN:         "sent_to_mn",
    MN_DECLINED:        "mn_declined",
    MN_CONFIRMED:       "mn_confirmed",
    SENT_TO_FAM:        "sent_to_fam",
    FAM_DECLINED:       "fam_declined",
    FAM_CONFIRMED:      "fam_confirmed",
    FINAL_CONFIRMATION: "final_confirmation",
    DONE: "done"
});

export const FeeType = Object.freeze({
    NONE:               "",
    PROTECTION_FEE:     "protection_fee",
    MEDIATION_FEE:      "mediation_fee"
});

export const TwoFactorAuthType = Object.freeze({
    NONE:               "",
    MOBILE:             "mobile",
    APP:                "app"
});

// DO NOT FORGET to adjust this in the backend as it is already required there for newsletter generation
export const NewsletterContentCategory = Object.freeze({
    NONE:           "",
    BLOG:           "blog",
    CUSTOM_URL:     "custom_url",
    NO_URL:         "no_url"
});

export const UserResultOrder = Object.freeze({
    NONE:                  "",
    MATCH_PERCENTAGE:      "match_percentage",
    MATCH_DISTANCE_KM:     "match_distance_km"
});

export const DisplayLanguage = Object.freeze({
    NONE:        "",
    GERMAN:      "german",
    ENGLISH:     "english"
});

export const InactivityAnswer = Object.freeze({
    NONE:                         "",
    DELETE_ACCOUNT_NOW:           "delete_account_now",
    DELETE_ACCOUNT_IN_4_MONTHS:   "delete_account_in_4_months",
    DELETE_ACCOUNT_IN_12_MONTHS:  "delete_account_in_12_months"
});

export const InactivityStatus = Object.freeze({
    NONE:                 "",
    QUERY_USER:           "query_user",
    USER_ANSWERED:        "user_answered"
});
